import React from 'react';
import { Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { devLog } from '../../utils';
import { usePageViews } from '../../utils/analytics';

const NotFound = () => {
  usePageViews();

  devLog('info', 'not found', window.location?.pathName);

  if (window.location?.pathName === undefined) {
    return <></>;
  }

  return (
    <div style={{ textAlign: 'center' }}>
      <Typography variant='subtitle1' style={{ marginBottom: 20 }}>
        We couldn&apos;t find the page you were looking for.
      </Typography>
      <Button variant='outlined' color='primary' component={Link} to='/logout'>
        Logout
      </Button>
    </div>
  );
};

export default NotFound;
